import React from 'react';
import styled, { css } from 'styled-components';
import { ButtonIcon, ButtonIconProps } from '@companycam/slab-web';

const ButtonIconStyled = styled(ButtonIcon)`
  ${(props: { $active?: boolean }) =>
    props.$active &&
    css`
      background-color: var(--cc_color_background_3);
      color: var(--cc_color_text_subtle);
    `}
`;

export type ToolbarIconButtonProps = {
  icon: ButtonIconProps['iconName'];
  active?: boolean;
  disabled?: ButtonIconProps['disabled'];
  onClick?: ButtonIconProps['onClick'];
  accessibilityLabel?: string;
  'data-testid'?: string;
};

export const ToolbarIconButton = ({
  icon,
  active,
  disabled,
  onClick,
  accessibilityLabel,
  'data-testid': testID,
}: ToolbarIconButtonProps) => {
  return (
    <ButtonIconStyled
      data-testid={testID}
      disabled={disabled}
      iconName={icon}
      size="small"
      design="minimal"
      $active={active}
      onClick={onClick}
      accessibilityLabel={accessibilityLabel}
    />
  );
};
